/**
 * @deprecated Use BuilderDocumentFormat from '@deltasierra/features-builder-templates-core' instead
 */
export enum BuilderDocumentFormat {
    content = 'DSCBDoc',
    email = 'DSETDoc',
    print = 'DSPBDoc',
    video = 'DSVBDoc',
}
